import { configureStore } from '@reduxjs/toolkit';
import mealReducer from '../Features/mealSlice';

const store = configureStore({
    reducer: {
        meal: mealReducer,
    },
});

export default store;
